import {Component, Input, OnInit} from '@angular/core';
import {BannersService} from '../../../services/banners.service';
import {BannerKey} from '../../../enums/banner-key.enum';

@Component({
  selector: 'app-step-banner',
  templateUrl: './step-banner.component.html',
  styleUrls: []
})
export class StepBannerComponent implements OnInit {

  @Input() currentStepKey: string;

  BannerKey = BannerKey;

  get bannerKey(): BannerKey {
    const stepBannerConfig = this.bannersService.getStepBannerConfig(this.currentStepKey);
    return stepBannerConfig ? stepBannerConfig.bannerKey : null;
  }

  constructor(public bannersService: BannersService) { }

  ngOnInit() {
  }

}
